module.exports = "pegasus_template/assets/tech/medium/8.png";